import type { Account } from './types';

export const mockAccounts: Account[] = [
  {
    id: 1,
    username: 'admin',
    realName: '张三',
    phone: '13800138001',
    email: 'zhangsan@example.com',
    employeeId: 'EMP001',
    departmentId: 1,
    departmentName: '技术部',
    roleId: 1,
    roleName: '超级管理员',
    status: true,
    lastLoginTime: '2024-03-15 14:32:18',
    createdAt: '2024-01-10 09:00:00',
  },
  {
    id: 2,
    username: 'lisi',
    realName: '李四',
    phone: '13800138002',
    email: 'lisi@example.com',
    employeeId: 'EMP002',
    departmentId: 2,
    departmentName: '运营部',
    roleId: 2,
    roleName: '运营管理员',
    status: true,
    lastLoginTime: '2024-03-15 11:25:43',
    createdAt: '2024-01-15 10:30:00',
  },
  {
    id: 3,
    username: 'wangwu',
    realName: '王五',
    phone: '13800138003',
    email: 'wangwu@example.com',
    employeeId: 'EMP003',
    departmentId: 1,
    departmentName: '技术部',
    roleId: 3,
    roleName: '技术管理员',
    status: true,
    lastLoginTime: '2024-03-15 09:18:22',
    createdAt: '2024-01-20 14:15:00',
  },
  {
    id: 4,
    username: 'zhaoliu',
    realName: '赵六',
    phone: '13800138004',
    email: 'zhaoliu@example.com',
    employeeId: 'EMP004',
    departmentId: 3,
    departmentName: '商品部',
    roleId: 4,
    roleName: '商品管理员',
    status: true,
    lastLoginTime: '2024-03-14 16:42:55',
    createdAt: '2024-02-01 11:20:00',
  },
  {
    id: 5,
    username: 'sunqi',
    realName: '孙七',
    phone: '13800138005',
    email: 'sunqi@example.com',
    employeeId: 'EMP005',
    departmentId: 4,
    departmentName: '客服部',
    roleId: 5,
    roleName: '客服专员',
    status: true,
    lastLoginTime: '2024-03-15 13:55:12',
    createdAt: '2024-02-05 09:45:00',
  },
  {
    id: 6,
    username: 'zhouba',
    realName: '周八',
    phone: '13800138006',
    email: 'zhouba@example.com',
    employeeId: 'EMP006',
    departmentId: 5,
    departmentName: '财务部',
    roleId: 6,
    roleName: '财务专员',
    status: true,
    lastLoginTime: '2024-03-15 10:28:37',
    createdAt: '2024-02-10 15:30:00',
  },
  {
    id: 7,
    username: 'wujiu',
    realName: '吴九',
    phone: '13800138007',
    email: 'wujiu@example.com',
    employeeId: 'EMP007',
    departmentId: 2,
    departmentName: '运营部',
    roleId: 2,
    roleName: '运营管理员',
    status: true,
    lastLoginTime: '2024-03-14 17:15:28',
    createdAt: '2024-02-15 13:10:00',
  },
  {
    id: 8,
    username: 'zhengshi',
    realName: '郑十',
    phone: '13800138008',
    email: 'zhengshi@example.com',
    employeeId: 'EMP008',
    departmentId: 4,
    departmentName: '客服部',
    roleId: 5,
    roleName: '客服专员',
    status: true,
    lastLoginTime: '2024-03-15 12:40:19',
    createdAt: '2024-02-20 10:25:00',
  },
  {
    id: 9,
    username: 'qianyi',
    realName: '钱一',
    phone: '13800138009',
    email: 'qianyi@example.com',
    employeeId: 'EMP009',
    departmentId: 1,
    departmentName: '技术部',
    roleId: 3,
    roleName: '技术管理员',
    status: false,
    lastLoginTime: '2024-03-10 08:52:33',
    createdAt: '2024-02-25 16:40:00',
  },
  {
    id: 10,
    username: 'chener',
    realName: '陈二',
    phone: '13800138010',
    email: 'chener@example.com',
    employeeId: 'EMP010',
    departmentId: 6,
    departmentName: '人事部',
    roleId: 7,
    roleName: '只读用户',
    status: true,
    lastLoginTime: '2024-03-15 08:15:47',
    createdAt: '2024-03-01 09:55:00',
  },
  {
    id: 11,
    username: 'linsan',
    realName: '林三',
    phone: '13800138011',
    email: 'linsan@example.com',
    employeeId: 'EMP011',
    departmentId: 4,
    departmentName: '客服部',
    roleId: 5,
    roleName: '客服专员',
    status: true,
    lastLoginTime: '2024-03-15 14:05:22',
    createdAt: '2024-03-05 11:30:00',
  },
  {
    id: 12,
    username: 'huangsi',
    realName: '黄四',
    phone: '13800138012',
    email: 'huangsi@example.com',
    employeeId: 'EMP012',
    departmentId: 3,
    departmentName: '商品部',
    roleId: 4,
    roleName: '商品管理员',
    status: true,
    lastLoginTime: '2024-03-14 15:38:56',
    createdAt: '2024-03-08 14:20:00',
  },
];

export const mockRoles = [
  { id: 1, name: '超级管理员' },
  { id: 2, name: '运营管理员' },
  { id: 3, name: '技术管理员' },
  { id: 4, name: '商品管理员' },
  { id: 5, name: '客服专员' },
  { id: 6, name: '财务专员' },
  { id: 7, name: '只读用户' },
];

export const mockDepartments = [
  { id: 1, name: '技术部' },
  { id: 2, name: '运营部' },
  { id: 3, name: '商品部' },
  { id: 4, name: '客服部' },
  { id: 5, name: '财务部' },
  { id: 6, name: '人事部' },
];
